export default __webpack_public_path__ + "static/media/Icons_Phone_Smartphone_Regular.277c981d.svg";